"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonthSeparator = exports.CalendarHeaderCellWrapper = exports.CalendarHeaderCellPadding = exports.CalendarCellWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _calendargrid = require("./calendargrid.tokens");
var _globalTokens = require("../../../../shared/global-tokens");
var getCursor = function getCursor(_ref) {
  var isDisabled = _ref.isDisabled,
    isUnavailable = _ref.isUnavailable;
  if (isDisabled || isUnavailable) {
    return 'inherit';
  }
  return 'pointer';
};
var getHoverColor = function getHoverColor(_ref2) {
  var isSelected = _ref2.isSelected,
    isSelectionStart = _ref2.isSelectionStart,
    isSelectionEnd = _ref2.isSelectionEnd,
    isDisabled = _ref2.isDisabled,
    isUnavailable = _ref2.isUnavailable,
    theme = _ref2.theme;
  if (isSelectionStart || isSelectionEnd) {
    return (0, _calendargrid.calendarGridTokens)(theme).color.background.selectionEdge;
  }

  // selected takes precedence over disabled for hovering, even though the use-case is weird
  if (isSelected) {
    return (0, _calendargrid.calendarGridTokens)(theme).color.background.selection;
  }
  if (isDisabled || isUnavailable) {
    return 'inherit';
  }
  return (0, _calendargrid.calendarGridTokens)(theme).color.background.selection;
};
var getBackgroundColor = function getBackgroundColor(_ref3) {
  var isSelected = _ref3.isSelected,
    isSelectionStart = _ref3.isSelectionStart,
    isSelectionEnd = _ref3.isSelectionEnd,
    theme = _ref3.theme;
  if (isSelectionStart || isSelectionEnd) {
    return (0, _calendargrid.calendarGridTokens)(theme).color.background.selectionEdge;
  } else if (isSelected) {
    return (0, _calendargrid.calendarGridTokens)(theme).color.background.selection;
  } else {
    return 'inherit';
  }
};
function getStrokeColor(_ref4) {
  var isSelectionStart = _ref4.isSelectionStart,
    isSelectionEnd = _ref4.isSelectionEnd,
    theme = _ref4.theme;
  return isSelectionStart || isSelectionEnd ? (0, _calendargrid.calendarGridTokens)(theme).color.highlight.onDark : (0, _calendargrid.calendarGridTokens)(theme).color.highlight.default;
}
var getBorderRadius = function getBorderRadius(_ref5) {
  var isSelectionStart = _ref5.isSelectionStart,
    isSelectionEnd = _ref5.isSelectionEnd,
    theme = _ref5.theme;
  if (isSelectionStart && isSelectionEnd) {
    return (0, _calendargrid.calendarGridTokens)(theme).border.radius.singleSelection;
  } else if (isSelectionStart) {
    return (0, _calendargrid.calendarGridTokens)(theme).border.radius.selectionStart;
  } else if (isSelectionEnd) {
    return (0, _calendargrid.calendarGridTokens)(theme).border.radius.selectionEnd;
  } else {
    return 'inherit';
  }
};
var CellWrapper = _styledComponents.default.div.withConfig({
  displayName: "Calendarstyled__CellWrapper",
  componentId: "sc-4zwojx-0"
})(["height:", ";width:", ";display:flex;justify-content:center;align-items:center;"], function (props) {
  return (0, _calendargrid.calendarGridTokens)(props.theme).size.cell.height;
}, function (props) {
  return (0, _calendargrid.calendarGridTokens)(props.theme).size.cell.width;
});
var CalendarCellWrapper = exports.CalendarCellWrapper = (0, _styledComponents.default)(CellWrapper).withConfig({
  displayName: "Calendarstyled__CalendarCellWrapper",
  componentId: "sc-4zwojx-1"
})(["visibility:", ";background-color:", ";border-radius:", ";position:relative;button{cursor:", ";z-index:2;background-color:transparent;width:", ";}svg{stroke:", ";width:", ";position:absolute;top:0;bottom:0;left:0;right:0;}&:hover{background-color:", ";}"], function (_ref6) {
  var hidden = _ref6.hidden;
  return hidden ? 'hidden' : 'visible';
}, getBackgroundColor, getBorderRadius, getCursor, function (props) {
  return (0, _calendargrid.calendarGridTokens)(props.theme).size.cell.width;
}, getStrokeColor, function (props) {
  return (0, _calendargrid.calendarGridTokens)(props.theme).size.cell.width;
}, getHoverColor);
var CalendarHeaderCellWrapper = exports.CalendarHeaderCellWrapper = (0, _styledComponents.default)(CellWrapper).withConfig({
  displayName: "Calendarstyled__CalendarHeaderCellWrapper",
  componentId: "sc-4zwojx-2"
})([""]);
var CalendarHeaderCellPadding = exports.CalendarHeaderCellPadding = _styledComponents.default.div.withConfig({
  displayName: "Calendarstyled__CalendarHeaderCellPadding",
  componentId: "sc-4zwojx-3"
})(["height:", ";width:", ";"], function (props) {
  return (0, _calendargrid.calendarGridTokens)(props.theme).size.cell.height;
}, function (props) {
  return (0, _calendargrid.calendarGridTokens)(props.theme).size.cell.width;
});
var MonthSeparator = exports.MonthSeparator = _styledComponents.default.div.withConfig({
  displayName: "Calendarstyled__MonthSeparator",
  componentId: "sc-4zwojx-4"
})(["width:1px;align-self:stretch;background-color:", ";margin:0 ", ";"], function (props) {
  return (0, _calendargrid.calendarGridTokens)(props.theme).color.border;
}, _globalTokens.globalSpacing[400]);